import { ca } from '@cian/analytics';

import { type PinService } from '@/microfrontends/map/shared/services/PinService';

import { type AnalyticsPage } from '@/packages/utils/analytics';

import { FPinType } from '../../../services/PinService/impl/types';

const prepareLabel = (pinService: PinService, zoom: number): string => {
  const pinType = pinService.provideType();

  const pinColor = pinType === FPinType.Regular ? 'blue' : 'white';

  return `${pinColor}/${zoom}`;
};

interface ITrackMapPinClickParams {
  pinService: PinService;
  zoom: number;
  page: AnalyticsPage;
}

export function trackMapPinClick({ pinService, zoom, page }: ITrackMapPinClickParams): void {
  ca('eventSite', {
    action: 'Click_pin',
    category: 'Map',
    label: prepareLabel(pinService, zoom),
    name: 'oldevent',
    page: { ...page, pageType: 'ListingHybrid', listingType: 'map', extra: {} },
  });
}
